(exports.GAME_ID = "60350504c1d3380015e09fb0"),
(exports.FORM_ID = "6035078ca323940015f50a0c"),
(exports.LINE_ITEM_ID = "60350a77a323940015f50a6c"),
(exports.UPDATE_ID = "60350e61a323940015f50aa9"),
(exports.QUESTIONNAIRE_ID = "60350e61a323940015f50aa9"),
(exports.STATUS_ID = "60365a630f7aaf0015cf7c6d"),
(exports.SERVER_URL = "https://api.lucien.ai"),
(exports.BD_NAME = "odr-robot-husqvarna-voucher");